module.exports = __webpack_public_path__ + "img/full-pgt-1.c496c556.jpg";